import { Stack } from "@fluentui/react";
import { Form, Formik } from "formik";
import NewFormField from "../../common/layout/form/NewFormField";
import NewFormBtns from "../../common/layout/form/NewFormBtns";
import MessageContainer from "../../auth/components/register/forms/MessageContainer";
import ActivityIndicator from "../../common/layout/ActivityIndicator";
import { useNotConfirmedUsers } from "../hooks/useNotConfirmedUsers";
import React from "react";
import DisplayText from "../../clients/components/edditionPanel/displayData/DisplayText";
import { useTranslation } from 'react-i18next';

const NotConfirmedUserForm: React.FC = () => {
    const { t } = useTranslation('admin');
    const { cancelForm, confirm, initValues, loading } = useNotConfirmedUsers();

    return (
        <Formik initialValues={initValues} onSubmit={confirm}>
            {({ handleSubmit }) => (
                <Form translate="yes" onSubmit={handleSubmit}>
                    <Stack>
                        <NewFormField name="lastName" label={t('notConfirmedUsers.form.lastName') as string} />
                        <NewFormField name="firstName" label={t('notConfirmedUsers.form.firstName') as string} />
                        <NewFormField name="phone" label={t('notConfirmedUsers.form.phone') as string} />
                        <DisplayText name={t('notConfirmedUsers.columns.email') as string} value={initValues.email} />
                        <NewFormBtns
                            positionAbsolute={true}
                            cancelForm={cancelForm}
                            submitBtnText={t('notConfirmedUsers.form.confirm') as string}
                            disabled={loading}
                        />
                    </Stack>
                    {loading ? <ActivityIndicator /> : <MessageContainer />}
                </Form>
            )}
        </Formik>
    );
};

export default NotConfirmedUserForm;